import { computed } from '@vue/composition-api'
import store from '@/store'
import { FLAG_CONSTANTS } from '@/constants'

/**
 * KP-3919's kill switch, read in one place so every surface agrees.
 *
 * ON  — multiple brand-catalogue files per collection, browser-direct
 *       multipart upload with pause/resume, and the Download Collection
 *       picker that delivers them as one structured ZIP.
 * OFF — exactly what shipped before KP-3919: the single-file upload controls,
 *       the plain "Download Excel" modal, and the retailer's original text
 *       "Download" button on the collection cards.
 *
 * Defaults to OFF when the flag store has not resolved yet, so a slow or
 * failed Flagsmith load degrades to the known-good behaviour rather than
 * showing a half-initialised new surface.
 */
export function isBrandCatalogueEnabled() {
  const hasFeature = store.getters && store.getters['flags/hasFeature']
  if (typeof hasFeature !== 'function') return false
  return Boolean(hasFeature(FLAG_CONSTANTS.KP_3919_BRAND_CATALOGUE_FILES))
}

/** Reactive form for use inside setup(). */
export function useBrandCatalogueFlag() {
  return { isBrandCatalogueEnabled: computed(() => isBrandCatalogueEnabled()) }
}
